module.exports = __webpack_public_path__ + "img/itf.0a820b1b.png";